<script type="text/babel">

    import AdjustableGeometry from "./AdjustableGeometry.vue";
    export default{
        data () {
            return {}
        },
        mounted () {
          (function() {
            const tabbed = document.querySelector('.db-category-tabs');
            const tablist = tabbed.querySelector('.db-category-tabs__triggers');
            const tabs = tablist.querySelectorAll('a');
            const panels = tabbed.querySelectorAll('[id^="db-category-tab-"]');

            const switchTab = (oldTab, newTab) => {
              newTab.focus();
              newTab.removeAttribute('tabindex');
              newTab.setAttribute('aria-selected', 'true');
              oldTab.removeAttribute('aria-selected');
              oldTab.setAttribute('tabindex', '-1');
              let index = Array.prototype.indexOf.call(tabs, newTab);
              let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
              panels[oldIndex].hidden = true;
              panels[index].hidden = false;
            }

            tablist.setAttribute('role', 'tablist');

            Array.prototype.forEach.call(tabs, (tab, i) => {
              tab.setAttribute('role', 'tab');
              tab.setAttribute('id', 'tab' + (i + 1));
              tab.setAttribute('tabindex', '-1');
              tab.parentNode.setAttribute('role', 'presentation');

              tab.addEventListener('click', e => {
                e.preventDefault();
                let currentTab = tablist.querySelector('[aria-selected]');
                if (e.currentTarget !== currentTab) {
                  switchTab(currentTab, e.currentTarget);
                }
              });

              tab.addEventListener('keydown', e => {
                let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
                let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
                if (dir !== null) {
                  e.preventDefault();
                  dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
                }
              });
            });

            Array.prototype.forEach.call(panels, (panel, i) => {
              panel.setAttribute('role', 'tabpanel');
              panel.setAttribute('tabindex', '-1');
              let id = panel.getAttribute('id');
              panel.setAttribute('aria-labelledby', tabs[i].id);
              panel.hidden = true;
            });

            tabs[0].removeAttribute('tabindex');
            tabs[0].setAttribute('aria-selected', 'true');
            panels[0].hidden = false;
          })();
        },
        props: [],
        computed: {
        },
        components: {
            'adjustable-geometry': AdjustableGeometry,
        },
        methods: {}
    }
</script>
